import { ref } from 'vue';
import { defineStore } from 'pinia';
import { useRoute } from 'vue-router';

import { useUserStore } from './user';

import { getParamsOnLoad } from '@/utils/storeMixin';
import type { ApiKey, ApiIndexQuery } from '@/types/Api';
import { getAPITokens } from '@/utils/api';

export const useApiStore = defineStore('api', () => {
  const userStore = useUserStore();
  const route = useRoute();

  const apiVersion = ref('');
  const keyData = ref<ApiKey[]>([]);
  const lastPage = ref(0);
  const loading = ref(false);

  const params = ref<ApiIndexQuery>({
    page: 1,
    results_per_page: 10,
    search: '',
    sortDesc: true,
    order: 'name',
  });

  const getData = async () => {
    loading.value = true;
    const newParams = { ...params.value };

    if (newParams.search === '') {
      delete newParams.search;
    }

    getAPITokens(userStore.accessToken, newParams).then((resp) => {
      const { data, last_page } = resp;
      keyData.value = data;
      lastPage.value = last_page;
      loading.value = false;
    });
  };

  function getQueryParamsOnLoad() {
    if (route.path.includes('/api')) {
      params.value = getParamsOnLoad(params.value);
    }
  }

  getQueryParamsOnLoad();

  return {
    apiVersion,
    keyData,
    lastPage,
    params,
    loading,
    getData,
  };
});
